import { $journalApi } from "@/entities/journal/fetch/fetch-client";

export const usePostSignEntry = () =>
  $journalApi.useMutation(
    "post",
    "/api/v1/journals/section-three/{sectionThreeListId}/items/{itemNoVersionId}/sign/done",
  );

